import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMappedvalue'
})
export class FilterMappedvaluePipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
    return it.privilege_name.toLowerCase().includes(searchText);
    });
   }


}

